// extracted by mini-css-extract-plugin
module.exports = {"notOpened":"styles_notOpened__1rDkG","wrapper":"styles_wrapper__1_lgM","tooltip":"styles_tooltip__3cwnP"};